/**
 * This functions converts emoji to unicode codepoint
 * e.g 🤵 -> 1f935, 🤵🏿 -> 1f935-1f3ff
 * @param emoji
 * @returns {string}
 */
export default emoji =>
  Array.from(emoji)
    .map(chars => chars.codePointAt(0).toString(16))
    .join('-')
